import { IAnalyticsResponse } from './../../../../api/models/uberal.models';
import { IUberallData } from './../../../../api/models/api-models';
import { createAction, props } from '@ngrx/store';

export enum UberallActionTypes {
  SET_UBERALL_DATA = '[UBERALL] Set Uberall Data',

  GET_ANALYTICS_ATTEMPT = '[Uberall Analytics] Get Analytics Attempt',
  GET_ANALYTICS_SUCCESS = '[Uberall Analytics] Get Analytics Success',
  GET_ANALYTICS_FAILURE = '[Uberall Analytics] Get Analytics Failure',
}

export const setUberallData = createAction(UberallActionTypes.SET_UBERALL_DATA, props<IUberallData>());

export const getAnalyticsAttempt = createAction(UberallActionTypes.GET_ANALYTICS_ATTEMPT);

export const getAnalyticsSuccess = createAction(UberallActionTypes.GET_ANALYTICS_SUCCESS, props<IAnalyticsResponse>());

export const getAnalyticsFailure = createAction(UberallActionTypes.GET_ANALYTICS_FAILURE);
